export const ENVIAR_MENSAGEM = 'ENVIAR_MENSAGEM';
export const ENVIAR_MENSAGEM_START = 'ENVIAR_MENSAGEM_START';
export const ENVIAR_MENSAGEM_SUCCESS = 'ENVIAR_MENSAGEM_SUCCESS';
export const ENVIAR_MENSAGEM_ERROR = 'ENVIAR_MENSAGEM_ERROR';

export const CHANGE_FIELD_CONTATO_VALUE = 'CHANGE_FIELD_CONTATO_VALUE';

export const FORMULARIO_CONTATO_RESET = 'FORMULARIO_CONTATO_RESET';
